import { create } from 'zustand';
var setting = create(function (set) { return ({
    articleInfo: {
        id: '',
        type: '',
    },
    setArticleInfo: function (id, type) {
        set(function () { return ({
            articleInfo: {
                id: id,
                type: type,
            },
        }); });
    },
    clearArticleInfo: function () {
        set(function () { return ({
            articleInfo: {
                id: '',
                type: '',
            },
        }); });
    },
}); });
export var useSettingStore = setting;
